import React from "react";

import ChevronDown from "@uui/ChevronDown";

import MuiAccordion, {
  AccordionProps as MuiAccordionProps,
} from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps as MuiAccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import styled from "@mui/material/styles/styled";

export type AccordionProps = MuiAccordionProps;
export type AccordionSummaryProps = MuiAccordionSummaryProps & {
  iconSize?: React.CSSProperties["fontSize"];
};

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion elevation={0} disableGutters {...props} />
))({
  "&::before": {
    display: "none",
  },
});

export const AccordionSummary = styled(
  ({ iconSize = "16px", ...props }: AccordionSummaryProps) => (
    <MuiAccordionSummary
      expandIcon={<ChevronDown sx={{ fontSize: iconSize }} />}
      {...props}
    />
  )
)({});

export default Accordion;
